import { Mail } from 'lucide-react';
import { WhatsAppIcon } from '../icons/WhatsAppIcon';
import logoLimiar from '../../assets/logo.png';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-primary">
      <div className="mx-auto max-w-6xl px-6 py-12">
        <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
          <div>
            <div className="flex items-center gap-2">
              <img
                src={logoLimiar}
                alt="Limiar Soluções Digitais"
                className="h-8 w-8 brightness-0 invert"
              />
              <span className="font-heading text-lg font-bold text-primary-foreground">
                Limiar
              </span>
            </div>
            <p className="mt-1 text-sm text-primary-foreground/60">
              Soluções Digitais
            </p>
          </div>

          <div className="flex items-center gap-6">
            <a
              href="mailto:contato@limiar.com.br"
              className="flex items-center gap-2 text-sm text-primary-foreground/60 transition-colors hover:text-accent"
            >
              <Mail className="h-4 w-4" />
              contato@limiar.com.br
            </a>
            <a
              href="https://wa.me/5581997550684"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-sm text-primary-foreground/60 transition-colors hover:text-accent"
            >
              <WhatsAppIcon className="h-4 w-4" />
              WhatsApp
            </a>
          </div>
        </div>

        <div className="mt-8 border-t border-primary-foreground/10 pt-8 text-center">
          <p className="text-xs text-primary-foreground/40">
            {currentYear} Limiar Soluções Digitais. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
